export default __webpack_public_path__ + "static/media/s-squiggle-157.a39aa7ca.svg";